"use strict";
/**
 * Sample fixtures for tests, documentation and the UI "Try sample values"
 * action. BASE_CASE mirrors the leadership-approved validation workbook
 * v1.1 (FinEdge_Retirement_Calculator_Validation_Model_v1.1.xlsx,
 * SHA-256 dbb94da567b0c4eaee859a7ae728ed15e106d732ca03e474d1554406b9609929).
 *
 * BLANK_INPUTS is the production first-load state: all personal financial
 * inputs are zero; assumption fields carry approved defaults; the 11%
 * accumulation return belongs to the SAMPLE only and must never appear
 * as a silently-active production default.
 *
 * Do NOT change these values without updating engine.test.ts and the
 * validation workbook — the tests hard-lock the reproduced numbers.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.BLANK_ON_FIRST_LOAD_FIELDS = exports.DEFAULT_INPUTS = exports.BLANK_INPUTS = exports.BASE_CASE = void 0;
exports.BASE_CASE = {
    // Timeline
    currentAge: 40,
    retirementAge: 60,
    planIncomeUntilAge: 90,
    // Lifestyle
    currentMonthlyExpenses: 100000,
    desiredRetirementLifestyleToday: 90000,
    // Accumulation
    existingRetirementInvestments: 2500000,
    currentMonthlySip: 30000,
    annualSipStepUp: 0.10,
    lumpSumAvailableNow: 500000,
    expectedLumpSumAtRetirement: 0,
    // Withdrawal
    monthlyDependableIncomeAtStart: 25000,
    incomeBeginsAtAge: 60,
    incomeEndsAtAge: 90,
    annualIncomeEscalation: 0.03,
    healthcareEmergencyReserveAtRetirement: 1000000,
    oneTimeExpenseAtRetirement: 0,
    desiredCorpusRemainingAtPlanEnd: 0,
    // Assumptions
    preRetirementInflation: 0.06,
    postRetirementInflation: 0.05,
    accumulationReturn: 0.11,
    withdrawalReturn: 0.08,
};
/**
 * Production first-load state. Personal financial inputs are zero at the
 * engine layer (the UI wraps these with a blank-field mask so the visitor
 * sees empty fields, not "0"). Assumption fields carry leadership-approved
 * planning defaults per Phase 2B specification:
 *
 *   Inflation before retirement       6%
 *   Inflation during retirement       5%
 *   Accumulation-stage return        10%
 *   Withdrawal-stage return           8%
 *   Dependable-income increase        0%
 *   Annual SIP step-up                0%  (visually blank until a SIP is entered)
 *
 * The 11% accumulation figure belongs to the SAMPLE ONLY and must never
 * silently become the production default.
 */
exports.BLANK_INPUTS = {
    currentAge: 0,
    retirementAge: 0,
    planIncomeUntilAge: 0,
    currentMonthlyExpenses: 0,
    desiredRetirementLifestyleToday: 0,
    existingRetirementInvestments: 0,
    currentMonthlySip: 0,
    annualSipStepUp: 0,
    lumpSumAvailableNow: 0,
    expectedLumpSumAtRetirement: 0,
    monthlyDependableIncomeAtStart: 0,
    incomeBeginsAtAge: 0,
    incomeEndsAtAge: 0,
    annualIncomeEscalation: 0,
    healthcareEmergencyReserveAtRetirement: 0,
    oneTimeExpenseAtRetirement: 0,
    desiredCorpusRemainingAtPlanEnd: 0,
    preRetirementInflation: 0.06,
    postRetirementInflation: 0.05,
    accumulationReturn: 0.10,
    withdrawalReturn: 0.08,
};
exports.DEFAULT_INPUTS = { ...exports.BLANK_INPUTS };
/**
 * Personal-financial fields that must render as VISUALLY BLANK on fresh
 * anonymous load. The UI keeps a companion set of "blank" flags so the
 * visitor sees an empty field even though the underlying engine value is
 * zero. Assumption fields are intentionally NOT in this list — they carry
 * approved production defaults.
 */
exports.BLANK_ON_FIRST_LOAD_FIELDS = [
    "currentAge",
    "retirementAge",
    "planIncomeUntilAge",
    "currentMonthlyExpenses",
    "desiredRetirementLifestyleToday",
    "existingRetirementInvestments",
    "currentMonthlySip",
    "annualSipStepUp",
    "lumpSumAvailableNow",
    "expectedLumpSumAtRetirement",
    "monthlyDependableIncomeAtStart",
    "incomeBeginsAtAge",
    "incomeEndsAtAge",
    "healthcareEmergencyReserveAtRetirement",
    "oneTimeExpenseAtRetirement",
    "desiredCorpusRemainingAtPlanEnd",
];
